'use client'
import React, { useState, useEffect } from "react";
import {get_instrument_by_isin} from "@/spotlight/client";
import { ThousandSeparator } from "@/library/components/formatters/NumberFormatters";

export default function SpotlightInstrumentInfoBarBlock({ blok }) {
  const { tickerTitle, isinTitle, numberOfSharesTitle } = blok;
  const [instrument, setInstrument] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const func = async () => {
      const instrument_ = await get_instrument_by_isin();
      setInstrument(instrument_);
      setIsLoading(false);
    }
    func();
  }, []);
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 py-6 bg-bg-color-light my-12 px-12 divide-y-2 sm:divide-x-2 sm:divide-y-0 divide-gray-300">
      <div className="text-center py-12">
        <p className="font-bold mb-1">{tickerTitle}</p>
        <p className="text-2xl font-bold text-tertiary-accent">
          {instrument.symbol}
        </p>{" "}
      </div>
      <div className="text-center py-12">
        <p className="font-bold mb-1">{numberOfSharesTitle}</p>
        <p className="text-2xl font-bold text-tertiary-accent">
          <ThousandSeparator number={instrument.numberOfShares} />
        </p>
      </div>
      <div className="text-center py-12">
        <p className="font-bold mb-1">{isinTitle}</p>
        <p className="text-2xl font-bold text-tertiary-accent">
          {instrument.isin}
        </p>
      </div>
    </div>
  );
}
